import { AxiosResponse } from "axios";
import { ScorecardExpiryNotificationAcknowledgementResult, ScorecardLicenseExpiryModalResult, ScorecardLicenseRenewalResult } from "../../Model/Dto/ScorecardLicenseExpiry/ScorecardLicenseExpiry";
import { axiosCoreInstance } from "../AxiosCoreInterceptor";
import * as ApiUrls from "./ApiUrl.ScorecardLicenseExpiry";

export const ScorecardLicenseExpiryService = {
    acknowledgeExpiryNotification: (scorecardExpiryNotificationId: number): 
        Promise<AxiosResponse<ScorecardExpiryNotificationAcknowledgementResult>> => axiosCoreInstance.post(`${ApiUrls.AcknowledgeExpiryNotification}/${scorecardExpiryNotificationId}`),

    showExpiryModal: (): 
        Promise<AxiosResponse<ScorecardLicenseExpiryModalResult>> => axiosCoreInstance.get(ApiUrls.ShowExpiryModal),

    showRenewalModal: (): 
        Promise<AxiosResponse<ScorecardLicenseRenewalResult>> => axiosCoreInstance.get(ApiUrls.ShowRenewalModal)
}